import React, { useEffect, useState, useRef } from 'react';
function useInView(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) setInView(true);
    }, {
      threshold
    });
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, [threshold]);
  return {
    ref,
    inView
  };
}
export function ProblemSection() {
  const {
    ref,
    inView
  } = useInView();
  const painPoints = [{
    icon: '🚫',
    title: 'Algoritmos sin piedad',
    desc: 'Tu CV es descartado antes de que un humano lea tu nombre. El sistema está diseñado para eliminarte.'
  }, {
    icon: '📭',
    title: 'Portales que son agujeros negros',
    desc: 'Infojobs, LinkedIn, ETTs... todos diseñados para perfiles junior. Para nosotras, son trampas de tiempo.'
  }, {
    icon: '💔',
    title: 'Tu experiencia tratada como lastre',
    desc: 'Décadas de conocimiento que el mercado tradicional ve como "sobrecualificación". Un insulto disfrazado.'
  }];
  return <section className="section-navy py-20 lg:py-28" ref={ref} data-id="element-156">
      <div className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-157">
        {/* Header */}
        <div className="text-center mb-16 transition-all duration-700" style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)'
      }} data-id="element-158">
          <p className="font-body font-bold tracking-widest text-sm uppercase mb-3" style={{
          color: '#C9A84C'
        }} data-id="element-159">
            El problema real
          </p>
          <h2 className="font-heading font-black mb-4" style={{
          color: '#FAF7F2',
          fontSize: 'clamp(1.8rem, 4vw, 3rem)'
        }} data-id="element-160">
            La Trampa del CV Tradicional
          </h2>
          <p className="font-body text-lg max-w-2xl mx-auto" style={{
          color: '#C8D8E8'
        }} data-id="element-161">
            Estás compitiendo en un juego donde las reglas las pone un algoritmo
            que te descarta antes de que un humano lea tu nombre.
          </p>
        </div>

        {/* Stat */}
        <div className="text-center mb-16 transition-all duration-700 delay-200" style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(30px)'
      }} data-id="element-162">
          <div className="inline-block px-8 py-6 rounded-2xl" style={{
          backgroundColor: 'rgba(201,168,76,0.1)',
          border: '1px solid rgba(201,168,76,0.3)'
        }} data-id="element-163">
            <p className="font-heading font-black" style={{
            color: '#C9A84C',
            fontSize: 'clamp(2.5rem, 6vw, 4rem)'
          }} data-id="element-164">
              73%
            </p>
            <p className="font-body text-base mt-1" style={{
            color: '#C8D8E8'
          }} data-id="element-165">
              de los CVs de mayores de 45 son descartados por algoritmos
              <br data-id="element-166" />
              <strong style={{
              color: '#E2C97E'
            }} data-id="element-167">
                antes de ser leídos por un humano
              </strong>
            </p>
          </div>
        </div>

        {/* Pain point cards */}
        <div className="grid md:grid-cols-3 gap-6 mb-16" data-id="element-168">
          {painPoints.map((point, i) => <div key={point.title} className="p-6 rounded-2xl transition-all duration-700" style={{
          backgroundColor: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(201,168,76,0.25)',
          opacity: inView ? 1 : 0,
          transform: inView ? 'translateY(0)' : 'translateY(30px)',
          transitionDelay: `${300 + i * 150}ms`
        }} data-id="element-169">
              <div className="text-3xl mb-4" data-id="element-170">{point.icon}</div>
              <h3 className="font-heading font-bold text-lg mb-2" style={{
            color: '#E2C97E'
          }} data-id="element-171">
                {point.title}
              </h3>
              <p className="font-body text-sm leading-relaxed" style={{
            color: '#A8C0D8'
          }} data-id="element-172">
                {point.desc}
              </p>
            </div>)}
        </div>

        {/* Transition */}
        <div className="text-center transition-all duration-700 delay-700" style={{
        opacity: inView ? 1 : 0,
        transform: inView ? 'translateY(0)' : 'translateY(20px)'
      }} data-id="element-173">
          <div className="gold-divider max-w-xs mx-auto mb-8" data-id="element-174" />
          <p className="font-heading italic text-xl lg:text-2xl" style={{
          color: '#C9A84C'
        }} data-id="element-175">
            Pero hay una puerta que nadie te ha mostrado...
          </p>
        </div>
      </div>
    </section>;
}